import { ReactNode } from "react";
import styles from "./grid.module.scss";
import classNames from "classnames";

type GridProps = {
  className?: string;
  children: ReactNode;
};

export function Grid({ className, children }: GridProps) {
  return <div className={classNames(styles.grid, className)}>{children}</div>;
}

export function GridCol({ children }: GridProps) {
  return (
    <div className={classNames(styles.gridCol, styles.sticky)}>{children}</div>
  );
}
